module.exports = __webpack_public_path__ + "img/summary.3a519d43.png";